<template>
    <div class="container mt-5">
        <div class="card">
            <div class="card-header">
                <h4>Dados do Usuário</h4>
            </div>
            <div class="card-body">
                <div class="form-group mb-3">
                    <label for="nome">Nome</label>
                    <input type="text" class="form-control" id="nome" v-model="vnome" :disabled="!modoEdicao" />
                </div>

                <div class="form-group mb-3">
                    <label for="senha">Senha</label>
                    <input type="password" class="form-control" id="senha" v-model="vsenha" :disabled="!modoEdicao" />
                </div>

                <div class="form-group mb-3">
                    <label for="cpf">CPF</label>
                    <input type="text" class="form-control" id="cpf" v-model="vcpf" :disabled="!modoEdicao" />
                </div>

                <div class="text-end">
                    <button type="button" class="btn btn-primary me-2" v-if="!modoEdicao" @click="modoEdicao = true">
                        Editar
                    </button>

                    <button type="submit" @click.prevent="salvarDados()" class="btn btn-success" v-else>
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import util from '../util';
export default {
    name: 'UsuarioForm',
    data() {
        return {
            modoEdicao: false,

            vnome: '',
            vsenha: '',
            vcpf: ''

        };
    },
    mounted() {
        // Simulando carregamento dos dados do usuário

        this.modoEdicao = false;

        this.mtdcarregadados();
    },
    methods: {
        mtdregistro(){
            let vself  = this;
            let registrocrud = {
              
                'nome'          : this.vnome,
                'senha'         : this.vsenha,
                'cpf'           : this.vcpf
            };
            let parametros      = [
                {parametro: 'op',           valor : 'salvadadosedita'},
                {parametro: 'opcrud',       valor : vself.opcrud},
                {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                {parametro: 'idusuario',    valor : localStorage.getItem('iduser')},
            ];
            let retorno     = util.reqaxios(parametros, 'post', util.servidor+'/controller/rotinalogin.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data)){
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.modoEdicao = false;
           
                }else{
                    let tpret = response.data.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: '+response.message)
            });
        },
        salvarDados() {
            if(!this.vnome){
                util.notif('error', 'Informação!', 'informe seu nome!');
                return
            }
            if(!this.vsenha){
                util.notif('error', 'Informação!', 'informe sua senha!');
                return
            }
            if(!this.vcpf){
                util.notif('error', 'Informação!', 'informe seu CPF!');
                return
            }
            this.mtdregistro();
        },
        mtdcarregadados() {
            let vself = this;
        
            let parametros = [
                { parametro: 'op', valor: 'pegardadosedita' },
                { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
      
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/rotinalogin.php');
            retorno.then(function (response) {
            
            
                vself.vnome  = response.data[0].nome;
                vself.vsenha = response.data[0].senha;
                vself.vcpf   = response.data[0].cpf;
            
            
            }).catch(function (response) {
                
            });
        },
    }
};
</script>

<style scoped>
.card {
    max-width: 500px;
    margin: auto;
}
</style>
